import React from "react";
import ProjectLogo from "components/UI/ProjectLogo";
import Investor from "components/UI/Investor";

const FundraisingView = ({ item }) => {
    console.log('item', item);
  return (
    <div className="overflow-y-auto max-h-65vh border m-4 p-4 bg-white rounded">
      <div className="px-4 py-2 flex items-center justify-between border-b">
        <label className="block text-xs mb-2 uppercase font-bold">Project Name</label>
        <div className="w-1/2">
          <ProjectLogo className="mr-2" logo={item.project} />
        </div>
      </div>

      <div className="px-4 py-2 flex items-center justify-between border-b">
        <label className="block text-xs mb-2 uppercase font-bold">Category</label>
        <div className="w-1/2">
          {item.categoryName}
        </div>
      </div>

      <div className="px-4 py-2 flex items-center justify-between border-b">
        <label className="block text-xs mb-2 uppercase font-bold">Lead Investors</label>
        <div className="w-1/2">
          <Investor investors={item.leadInvestors} />
        </div>
      </div>

      <div className="px-4 py-2 flex items-center justify-between border-b">
        <label className="block text-xs mb-2 uppercase font-bold">Investors</label>
        <div className="w-1/2">
          <Investor investors={item.investors} />
        </div>
      </div>

      <div className="px-4 py-2 flex items-center justify-between border-b">
        <label className="block text-xs mb-2 uppercase font-bold">Total Raise</label>
        <div className="w-1/2">
          {item.totalRaise}
        </div>
      </div>

      <div className="px-4 py-2 flex items-center justify-between border-b">
        <label className="block text-xs mb-2 uppercase font-bold">Raised Date</label>
        <div className="w-1/2">
          {item.raiseDate}
        </div>
      </div>

      <div className="px-4 py-2 flex items-center justify-between border-b">
        <label className="block text-xs mb-2 uppercase font-bold">Announcement Link</label>
        <div className="w-1/2">
          {item.announcementLink ? item.announcementLink : 'N/A'}
        </div>
      </div>

      <div className="px-4 py-2 flex items-center justify-between border-b">
        <label className="block text-xs mb-2 uppercase font-bold">Created By</label>
        <div className="w-1/2">
          {item.username}
        </div>
      </div>
    </div>
  );
}
export default FundraisingView;